import api from "./Api";

class SituacaoPedidoService {
  GetSituacaoPedido(payload) {
    return api.get("/v1/situacaoPedido/" + payload).then((response) => {
      return response.data;
    });
  }

  PostSituacaoPedido(payload) {
    return api.post("/v1/situacaoPedido/", payload).then((response) => {
      return response.data;
    });
  }

  PutSituacaoPedido(payload) {
    return api.put("/v1/situacaoPedido/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteSituacaoPedido(payload) {
    return api.delete("/v1/situacaoPedido/" + payload).then((response) => {
      return response.data;
    });
  }

  GetSituacaoPedidoOData(payload) {
    return api.get("/OData/SituacaoPedido" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new SituacaoPedidoService();
